module.exports = __webpack_public_path__ + "static/img/1061_small.106d38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1061_small.png
// module id = b1bt
// module chunks = 1